import React from 'react';
import { BASEMAP_TILE_SOURCES } from '../../lib/map-styles';
import useTerrainSettings from '../../hooks/useTerrainSettings';

const BASEMAP_OPTIONS = Object.entries(BASEMAP_TILE_SOURCES).map(([k, v]) => [k, v.label]);

/**
 * 3D viewer terrain block (Viewer3D layer panel): drape on/off, hillshade, elevation, satellite, street or
 * topographic texture, vertical exaggeration. The DEM is the project's (set on the dataset page or
 * the map); without one the block says how to get one.
 */
export default function TerrainControls3D({ C, ready = false }) {
  const t = useTerrainSettings();
  const box = { marginBottom: 6, padding: '8px 10px', background: C.bg3, borderRadius: 8, border: `1px solid ${C.border}` };
  const hasDem = !!t.demDatasetId;
  return (
    <div style={box} data-testid="terrain-3d">
      <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 11, fontWeight: 600, color: C.text0 }}>
        <input type="checkbox" checked={t.drape3d} onChange={(e) => t.set({ drape3d: e.target.checked })} />
        {hasDem ? 'DEM terrain' : 'Terrain / ground image'} {t.drape3d && !ready && <span style={{ fontWeight: 400, color: C.text3 }}>(loading…)</span>}
      </label>
      <div style={{ fontSize: 9, color: C.text3, marginTop: 2 }}>
        {hasDem
          ? `${t.dem?.name || t.demDatasetId}${t.dem?.vertical_datum ? ` · ${t.dem.vertical_datum}` : ''}`
          : 'No project DEM: a basemap texture is drawn on a flat ground plane. For real relief, open a DEM dataset and choose “Use as project DEM”.'}
      </div>
      <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 10, color: C.text2, marginTop: 6 }}>
        Texture
        <select value={t.drapeStyle} onChange={(e) => t.set({ drapeStyle: e.target.value })}
          style={{ flex: 1, fontSize: 10, background: C.bg2, color: C.text1, border: `1px solid ${C.border}`, borderRadius: 4 }}>
          <option value="hillshade" disabled={!hasDem}>Hillshade</option>
          <option value="elevation" disabled={!hasDem}>Elevation</option>
          {BASEMAP_OPTIONS.map(([k, label]) => <option key={k} value={k}>{label}</option>)}
        </select>
      </label>
      <label style={{ display: 'block', fontSize: 10, color: C.text2, marginTop: 6 }}>
        Surface opacity {Math.round(Number(t.surfaceOpacity3d) * 100)}%
        <input type="range" min={0.1} max={1} step={0.05} value={t.surfaceOpacity3d} aria-label="Surface opacity"
          onChange={(e) => t.set({ surfaceOpacity3d: Number(e.target.value) })} style={{ width: '100%' }} />
      </label>
      <label style={{ display: 'block', fontSize: 10, color: C.text2, marginTop: 6 }}>
        Vertical exaggeration ×{Number(t.ve3d).toFixed(1)}
        <input type="range" min={0.5} max={10} step={0.5} value={t.ve3d} aria-label="Vertical exaggeration"
          onChange={(e) => t.set({ ve3d: Number(e.target.value) })} style={{ width: '100%' }} />
      </label>
    </div>
  );
}
